import React, { Component } from 'react'
import reactCSS from 'reactcss'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import LineStyleIcon from '@material-ui/icons/LineStyle';
export default class LatterSpacingPicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayLatterSpacingPicker: false,
            align: 'left',
        }
    }
    handleClick = () => {
        this.setState({ displayLatterSpacingPicker: !this.state.displayLatterSpacingPicker })
    };

    handleClose = () => {
        this.setState({ displayLatterSpacingPicker: false })
    };

    handleChange = (e) => {
        const val = e.target.value;
        this.props.handleRadioChange(val);
    };
    render() {
        const styles = reactCSS({
            'default': {
                color: {
                    width: '30px',
                    height: '5px',
                    borderRadius: '2px',
                },
                swatch: {
                    padding: '1px',
                    background: '#fff',
                    borderRadius: '1px',
                    display: 'inline-block',
                    cursor: 'pointer',
                    textAlign: 'center',
                    fontSize: '20px',
                    border: 'none',
                    margin: '6px 0px 0px 3px'
                },
                popover: {
                    marginTop: '5px',
                    position: 'absolute',
                    zIndex: '2',
                    backgroundColor: 'whitesmoke',
                    minWidth: '120px',
                    padding: '5px 5px 3px 5px',
                    boxShadow: '2px 2px 15px rgb(0 0 0 / 10%)'
                },

                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                    zIndex: -1
                },
            },
        });

        return (
            <div>
                <div style={styles.swatch} onClick={this.handleClick}>
                    <LineStyleIcon />

                </div>
                {this.state.displayLatterSpacingPicker ? <div style={styles.popover}>
                    <div style={styles.cover} onClick={this.handleClose} />
                    <RadioGroup className='letter-spacing-list' aria-label="quiz" name="quiz" value={this.props.letterSpacing} onChange={this.handleChange}>
                        <FormControlLabel value={`1px`} control={<Radio />} label="1px" />
                        <FormControlLabel value={`2px`} control={<Radio />} label="2px" />
                        <FormControlLabel value={`3px`} control={<Radio />} label="3px" />
                        <FormControlLabel value={`4px`} control={<Radio />} label="4px" />
                    </RadioGroup>
                </div> : null}

            </div>
        )
    }

}
